import Vue from 'vue';
import { hashCode } from '@piri/utils';
import { ContentTransformPlugin } from 'piri/content-transform';
import { useOverlaySpinnerLoading } from '../../../helpers/loadings';

import modules from './modules';
import itemIdentifiers from './itemIdentifiers';

const onRetrieveData = vm => {
  const key = hashCode(vm.$vnode.key);
  useOverlaySpinnerLoading().show(key);
};

const afterRetrieveData = vm => {
  const key = hashCode(vm.$vnode.key);
  useOverlaySpinnerLoading().hide(key);
};

const onError = vm => {
  const key = hashCode(vm.$vnode.key);
  useOverlaySpinnerLoading().hide(key);
};

// TODO: Dil seçimi entegrasyonu yapıldıktan sonra,
// seçili dil kaynağından okunarak
// burada döndürülecek.

const selectedLanguage = () => 'tr';

Vue.use(ContentTransformPlugin, {
  itemIdentifiers,
  modules,
  onRetrieveData,
  afterRetrieveData,
  onError,
  selectedLanguage,
});
